import styled from "styled-components";
import { Box, Flex, darkColors } from "@pancakeswap/uikit";

export const StyledFooter = styled(Flex)`
  background: ${darkColors.backgroundAlt};
  .link-wrap {
    display: flex;
    white-space: nowrap;
    ul:first-child {
      margin-right: 70px;
    }
  }
  .logo-wrap {
    margin: 0 0 0 20px;
    ${({ theme }) => theme.mediaQueries.lg} {
      margin: 20px 80px 0 40px;
    }
  }
  .email-wrap {
    line-height: 1.6;
    display: none;

    ${({ theme }) => theme.mediaQueries.lg} {
      margin-top: 24px;
      text-align: center;
      justify-content: center;
      display: flex;
    }
  }
  .mobile-email {
    ${({ theme }) => theme.mediaQueries.lg} {
      display: none;
    }
  }
`;

export const StyledList = styled.ul`
  list-style: none;
  margin: 20px;
  ${({ theme }) => theme.mediaQueries.lg} {
    margin: 20px 100px;
    &:last-child {
      .m0 {
        margin: 12px 0;
      }
    }
  }
  li {
    line-height: 1.5
  }
  &.right {
    width: 300px;
    margin-right: 40px;
    li {
      width: 100%;
    }
    .link {
      display: inline-block;
      &:hover {
        opacity: .8;
      }
    }
    ul {
      margin: 24px 0;
      ${({ theme }) => theme.mediaQueries.lg} {
        margin: 20px;
      }
    }
  }
`;

export const StyledListItem = styled.li`
  font-size: 14px;
  margin-bottom: 8px;
  text-transform: capitalize;
  color: #8A8A8A;

  &:first-child {
    font-size: 16px;
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;
  }
`;

export const StyledIconMobileContainer = styled(Box)`
  margin-bottom: 24px;
`;

export const StyledToolsContainer = styled(Flex)`
  border-color: ${darkColors.cardBorder};
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  padding: 24px 0;
  margin-bottom: 24px;

  ${({ theme }) => theme.mediaQueries.sm} {
    border-top-width: 0;
    border-bottom-width: 0;
    padding: 0 0;
    margin-bottom: 0;
  }
`

export const StyleInputWrap = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, .3) !important;
  position: relative;
  width: 90%;

  ${({ theme }) => theme.mediaQueries.lg} {
    width: 300px;
  }
  input {
    width: 100%;
    padding: 6px 30px 6px 0;
    border: 0;
    outline: 0;
    background: transparent;
    color: #fff;
  }
  .icon {
    display: block;
    width: 24px;
    position: absolute;
    top: 6px;
    right: 0;
  }
`
